import React, { useState } from "react";
import styles from "./ScrollableCard.module.css";
import { Link, useNavigate } from "react-router-dom";

import ScrollableCardSkeleton from './ScrollableCardSkeleton';

/** REUSEABLE COMPONENTS */
import CategoryTitle from "../../reusable/categoryTitle/CategoryTitle";
import CategorySeeAllButton from "../../reusable/categorySeeAll/CategorySeeAll";


const ScrollableCard = ({
  data,
  title,
  category_id = null,
  category_type = null,
}) => {
  const navigate = useNavigate();

  const handleClick = (id) => {
    navigate(`/music/detail/${category_type}/${id}`,  { state: { type: "one", normal : true } });
  };
  return (
    <div className={`w-full`}>
      <div className="my-4 flex justify-center">
        <CategoryTitle title={title}/>
        {category_id && category_type && (
          <CategorySeeAllButton to={`/music/see_all/${category_id}/${category_type}`} />
        )}
      </div>
      <div className={`${styles.imageContainer} my-4 mx-0`}>
        {
          data.map((item, index) => (
            <div
              className={`${index === data.length - 1 ? "" : "mr-4"} ${
                styles.scrollableImage
              }`}
              key={index}
              onClick={() => handleClick(item.id)}
            >
              <img
                src={item.image}
                key={index}
                alt={`Image ${index + 1}`}
                className={`${styles.image} rounded-lg`}
              />
              <span className="block text-sm mt-2 truncate pb-1">{item.title}</span>
              <span className="block text-xs truncate py-1">{item.desc}</span>
            </div>
          ))
        }
      </div>
    </div>
  );
};

export default ScrollableCard;
